module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stacks"
  }, [_c('ul', {
    ref: "stacks",
    staticClass: "stack-list"
  }, [(_vm.user) ? _c('create-stack-form', {
    attrs: {
      "user": _vm.user
    }
  }) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "card stack",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'cards'
        })
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'cards'
      }
    }
  }, [_c('h2', {
    staticClass: "stack-title"
  }, [_vm._v("My cards")])])], 1), _vm._v(" "), _vm._l((_vm.stacks), function(stack) {
    return _c('stack', {
      key: stack.key,
      attrs: {
        "stack": stack,
        "user": _vm.user
      }
    })
  })], 2), _vm._v(" "), _c('update-stack-modal')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-069bf253"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Stacks.vue
// module id = 189
// module chunks = 1